import { ResourceType } from "@common/types/auditLog";
import { APIProcessName } from "../process-names";
import { HistoryField, HistoryGroupBy } from "./history-fields";
import type {
    HistorySourceTypeConfig,
    ResourceTypeConfig,
} from "./history-source-config";

const TRANSACTION_RULE_FIELDS = [
    HistoryField.CONDITIONS,
    HistoryField.ACTIONS,
    HistoryField.IS_DISABLED,
    HistoryField.GROUP_ID,
    HistoryField.RULE_NOTE,
    HistoryField.SOURCE,
];

const TRANSACTION_RULE_GROUP_FIELDS = [HistoryField.NAME, HistoryField.TYPE];

const RULE_RESOURCE_TYPE_CONFIGS: ResourceTypeConfig[] = [
    ResourceType.TRANSACTION_RULE,
    ResourceType.ACCOUNTING_RULE,
    ResourceType.TRANSFER_RULE,
    ResourceType.SPLIT_RULE,
].map((resourceType) => ({
    resourceType,
    fields: TRANSACTION_RULE_FIELDS,
    resolveEntity: true,
}));

export const transactionRuleSources: HistorySourceTypeConfig[] = [
    {
        sourceType: APIProcessName.RULE_CREATE,
        resourceTypeConfigs: RULE_RESOURCE_TYPE_CONFIGS,
        groupBy: HistoryGroupBy.NONE,
        platformTwins: [APIProcessName.PLATFORM_CREATE_TRANSACTION_RULE],
        enabled: true,
    },
    {
        sourceType: APIProcessName.RULE_UPDATE,
        resourceTypeConfigs: RULE_RESOURCE_TYPE_CONFIGS,
        groupBy: HistoryGroupBy.NONE,
        platformTwins: [APIProcessName.PLATFORM_UPDATE_TRANSACTION_RULE],
        enabled: true,
    },
    {
        sourceType: APIProcessName.RULE_DELETE,
        resourceTypeConfigs: RULE_RESOURCE_TYPE_CONFIGS,
        groupBy: HistoryGroupBy.NONE,
        platformTwins: [APIProcessName.PLATFORM_DELETE_TRANSACTION_RULE],
        enabled: true,
    },
    {
        sourceType: APIProcessName.RULE_NOTE_UPDATE,
        resourceTypeConfigs: RULE_RESOURCE_TYPE_CONFIGS,
        groupBy: HistoryGroupBy.NONE,
        platformTwins: null,
        enabled: true,
    },
];

export const transactionRuleGroupSources: HistorySourceTypeConfig[] = [
    {
        sourceType: APIProcessName.RULE_GROUP_CREATE,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.TRANSACTION_RULE_GROUP,
                fields: TRANSACTION_RULE_GROUP_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.NONE,
        platformTwins: null,
        enabled: true,
    },
    {
        sourceType: APIProcessName.RULE_GROUP_UPDATE,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.TRANSACTION_RULE_GROUP,
                fields: TRANSACTION_RULE_GROUP_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.FIELD,
        platformTwins: null,
        enabled: true,
    },
    {
        sourceType: APIProcessName.RULE_GROUP_DELETE,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.TRANSACTION_RULE_GROUP,
                fields: TRANSACTION_RULE_GROUP_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.NONE,
        platformTwins: null,
        enabled: true,
    },
];
